<template>
  <div class="overflow-x-auto mt-6">
    <table class="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
      <thead>
        <tr>
          <th class="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
            ID
          </th>
          <th class="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
            Полное имя
          </th>
          <th class="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
            Email
          </th>
          <th class="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
            Роль
          </th>
          <th class="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
            Действия
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="admin in admins" :key="admin.id" class="hover:bg-gray-100">
          <td class="px-6 py-4 border-b border-gray-200 text-sm text-gray-700">
            {{ admin.id }}
          </td>
          <td class="px-6 py-4 border-b border-gray-200 text-sm text-gray-700">
            {{ admin.full_name }} {{ admin.last_name }}
          </td>
          <td class="px-6 py-4 border-b border-gray-200 text-sm text-gray-700">
            {{ admin.email }}
          </td>
          <td class="px-6 py-4 border-b border-gray-200 text-sm text-gray-700">
            {{ admin.role }}
          </td>
          <td class="px-6 py-4 border-b border-gray-200 text-sm text-gray-700 flex items-center space-x-2">
            <button @click="editAdmin(admin)" class="text-blue-500 hover:text-blue-700">
              <i class="fas fa-edit"></i> <!-- Edit Icon -->
            </button>
            <button @click="deleteAdmin(admin.id)" class="text-red-500 hover:text-red-700">
              <i class="fas fa-trash-alt"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
export default {
  name: "AdminTable",
  props: {
    admins: {
      type: Array,
      required: true,
    },
  },
  methods: {
    editAdmin(admin) {
      console.log("Edit admin:", admin);
    },
    deleteAdmin(adminId) {
      this.$emit("delete-admin", adminId);
    },
  },
};
</script>